/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InfrastructureExposureMaxLimitViewModel
 */
export interface InfrastructureExposureMaxLimitViewModel {
    /**
     * 
     * @type {number}
     * @memberof InfrastructureExposureMaxLimitViewModel
     */
    percentage?: number;
    /**
     * 
     * @type {number}
     * @memberof InfrastructureExposureMaxLimitViewModel
     */
    local?: number;
    /**
     * 
     * @type {number}
     * @memberof InfrastructureExposureMaxLimitViewModel
     */
    foreign?: number;
}

/**
 * Check if a given object implements the InfrastructureExposureMaxLimitViewModel interface.
 */
export function instanceOfInfrastructureExposureMaxLimitViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InfrastructureExposureMaxLimitViewModelFromJSON(json: any): InfrastructureExposureMaxLimitViewModel {
    return InfrastructureExposureMaxLimitViewModelFromJSONTyped(json, false);
}

export function InfrastructureExposureMaxLimitViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InfrastructureExposureMaxLimitViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'percentage': !exists(json, 'Percentage') ? undefined : json['Percentage'],
        'local': !exists(json, 'Local') ? undefined : json['Local'],
        'foreign': !exists(json, 'Foreign') ? undefined : json['Foreign'],
    };
}

export function InfrastructureExposureMaxLimitViewModelToJSON(value?: InfrastructureExposureMaxLimitViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Percentage': value.percentage,
        'Local': value.local,
        'Foreign': value.foreign,
    };
}

